/**
 * TanStack Query hooks for Apple Health snapshots.
 */

import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../client'
import type { AppleHealthSnapshotOut } from '../types'
import { OPTIONAL_QUERY_DEFAULTS } from './shared'

export function useAppleHealthSnapshots(limit = 10) {
  return useQuery({
    queryKey: ['apple-health-snapshots', limit],
    queryFn: () => apiFetch<AppleHealthSnapshotOut[]>(`/api/apple-health/snapshots?limit=${limit}`),
    ...OPTIONAL_QUERY_DEFAULTS,
  })
}
